import { Button } from "@components";
import { useEffect, useMemo, useState } from "react";
import styles from "styles/pages/reports/reports.module.scss";

import * as echarts from "echarts";
import { Currency } from "shared/utils/Currency";
import ComboFilters from "../../ComboFilters";
import { Numbers } from "shared/utils/Numbers";
import { formatByType } from "pages/Reports/Reports";

export default function CouponsInPeriod({ data = [], isBeforeSeptember }) {
  const [selectedOption, setSelectedOption] = useState({
    name: "Faturamento bruto",
    id: "FATURAMENTO",
  });

  const _data = {
    FATURAMENTO: {
      series: ["Faturamento bruto"],
      value_type: "currency",
      colors: ["#f288a4"],
      data: [data.map((d) => d.total?.value || 0)],
    },
    FATURAMENTO_LIQUIDO: {
      series: ["Faturamento líquido"],
      value_type: "currency",
      colors: ["#f288a4"],
      data: [data.map((d) => d.total_with_discounts?.value || 0)],
    },
    QTD_USOS: {
      series: ["Qtd. Usos"],
      value_type: "int",
      colors: ["#f288a4"],
      data: [data.map((d) => d.uses?.value || 0)],
    },
    TICKET_MEDIO: {
      series: ["Ticket médio bruto"],
      value_type: "currency",
      colors: ["#f288a4"],
      data: [data.map((d) => d.average_ticket?.value || 0)],
    },
    TICKET_MEDIO_LIQUIDO: {
      series: ["Ticket médio líquido"],
      value_type: "currency",
      colors: ["#f288a4"],
      data: [data.map((d) => d.average_ticket_with_discounts?.value || 0)],
    },
    TEMPO_MEDIO_USO: {
      series: ["Tempo médio p/ uso"],
      value_type: "float",
      colors: ["#f288a4"],
      data: [data.map((d) => d.average_time_to_use?.value || 0)],
    },
    DESCONTOS_TOTAIS: {
      series: ["Descontos totais"],
      value_type: "currency",
      colors: ["#f288a4"],
      data: [data.map((d) => d.discounts?.value || 0)],
    },
    ROI_CUPOM: {
      series: ["ROI"],
      value_type: "float",
      colors: ["#f288a4"],
      data: [data.map((d) => d.roi?.value || 0)],
    },
  };

  const totalData = [];

  const getDataByIndex = (index) => {
    return data[index];
  };

  const memoData = useMemo(() => data, [JSON.stringify(data)]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const chartDOM = document.getElementById("coupons-in-period-chart");
      const chart = echarts.init(chartDOM, null, {
        renderer: "svg",
      });

      const selectedOptionId = selectedOption.id;

      const options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          backgroundColor: "#2B2B2B",
          borderRadius: 8,
          padding: [8, 8],
          borderWidth: 0,
          textStyle: {
            color: "#FFF",
            fontSize: 10,
          },
          formatter: (params) => {
            const index = params[0].dataIndex;
            const item = getDataByIndex(index);

            return `
              <div>
              ${
                selectedOption.id === "QTD_USOS"
                  ? `<div style="background-color: rgba(97, 97, 255, 0.15);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div>
                    <span style="color:#8a8af5;font-weight:700">
                      Qtd. de usos: 
                    </span>  
                    <span style="color:#fff;margin-left:4px;">
                      ${item.uses.value || 0}
                    </span>  
                  </div>
                </div>`
                  : ""
              }

                            ${
                              selectedOption.id === "FATURAMENTO"
                                ? `<div style="background-color: rgba(97, 97, 255, 0.15);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div>
                    <span style="color:#8a8af5;font-weight:700">
                      Faturamento bruto: 
                    </span>  
                    <span style="color:#fff;margin-left:4px;">
                      ${Currency.formatCurrency(item.total.value)}
                    </span>  
                  </div>
                </div>`
                                : ""
                            }

                                          ${
                                            selectedOption.id ===
                                            "DESCONTOS_TOTAIS"
                                              ? `<div style="background-color: rgba(97, 97, 255, 0.15);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div>
                    <span style="color:#8a8af5;font-weight:700">
                      Descontos totais: 
                    </span>  
                    <span style="color:#fff;margin-left:4px;">
${isBeforeSeptember ? "---" : Currency.formatCurrency(item.discounts.value)}
                    </span>  
                  </div>
                </div>`
                                              : ""
                                          }

                                                        ${
                                                          selectedOption.id ===
                                                          "FATURAMENTO_LIQUIDO"
                                                            ? `<div style="background-color: rgba(97, 97, 255, 0.15);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div>
                    <span style="color:#8a8af5;font-weight:700">
                      Faturamento líquido: 
                    </span>  
                    <span style="color:#fff;margin-left:4px;">
${Currency.formatCurrency(item.total_with_discounts?.value)}
                    </span>  
                  </div>
                </div>`
                                                            : ""
                                                        }

                                                                      ${
                                                                        selectedOption.id ===
                                                                        "TICKET_MEDIO"
                                                                          ? `<div style="background-color: rgba(97, 97, 255, 0.15);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div>
                    <span style="color:#8a8af5;font-weight:700">
                      Ticket médio bruto: 
                    </span>  
                    <span style="color:#fff;margin-left:4px;">
${Currency.formatCurrency(item.average_ticket.value)}
                    </span>  
                  </div>
                </div>`
                                                                          : ""
                                                                      }

                                                                                    ${
                                                                                      selectedOption.id ===
                                                                                      "TICKET_MEDIO_LIQUIDO"
                                                                                        ? `<div style="background-color: rgba(97, 97, 255, 0.15);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div>
                    <span style="color:#8a8af5;font-weight:700">
                      Ticket médio líquido: 
                    </span>  
                    <span style="color:#fff;margin-left:4px;">
${Currency.formatCurrency(item.average_ticket_with_discounts?.value)}
                    </span>  
                  </div>
                </div>`
                                                                                        : ""
                                                                                    }

                                                                                                  ${
                                                                                                    selectedOption.id ===
                                                                                                    "TEMPO_MEDIO_USO"
                                                                                                      ? `<div style="background-color: rgba(97, 97, 255, 0.15);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div>
                    <span style="color:#8a8af5;font-weight:700">
                      Tempo médio para uso: 
                    </span>  
                    <span style="color:#fff;margin-left:4px;">
${Numbers.formatInt(item.average_time_to_use.value)} dias
                    </span>  
                  </div>
                </div>`
                                                                                                      : ""
                                                                                                  }

                                                                                                  ${
                                                                                                    selectedOption.id ===
                                                                                                    "ROI_CUPOM"
                                                                                                      ? `<div style="background-color: rgba(97, 97, 255, 0.15);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div>
                    <span style="color:#8a8af5;font-weight:700">
                      ROI do cupom: 
                    </span>  
                    <span style="color:#fff;margin-left:4px;">${
                      isBeforeSeptember ? "---" : item.roi?.value || 0
                    }
                    </span>  
                  </div>
                </div>`
                                                                                                      : ""
                                                                                                  }

              ${
                selectedOption.id !== "FATURAMENTO"
                  ? `                <div style="line-height:20px">
                  <span style="color:#fff;opacity:50%">Faturamento bruto:</span>
                  <span style="color:#fff">${Currency.formatCurrency(
                    item.total.value
                  )}</span>
                </div>`
                  : ""
              }

                            ${
                              selectedOption.id !== "DESCONTOS_TOTAIS"
                                ? `                <div style="line-height:20px">
                  <span style="color:#fff;opacity:50%">Descontos totais:</span>
                  <span style="color:#fff">${
                    isBeforeSeptember
                      ? "---"
                      : Currency.formatCurrency(item.discounts.value)
                  }</span>
                </div>`
                                : ""
                            }

              
                            ${
                              selectedOption.id !== "FATURAMENTO_LIQUIDO"
                                ? `                <div style="line-height:20px">
                  <span style="color:#fff;opacity:50%">Faturamento líquido:</span>
                  <span style="color:#fff">${Currency.formatCurrency(
                    item.total_with_discounts?.value
                  )}</span>
                </div>`
                                : ""
                            }

                                          ${
                                            selectedOption.id !== "QTD_USOS"
                                              ? ` <div style="line-height:20px">
                  <span style="color:#fff;opacity:50%">Qtd. de usos:</span>
                  <span style="color:#fff">
                    ${item.uses.value || 0}
                  </span>
                </div>`
                                              : ""
                                          }

              ${
                selectedOption.id !== "TICKET_MEDIO"
                  ? `                <div style="line-height:20px">
                  <span style="color:#fff;opacity:50%">Ticket médio bruto:</span>
                  <span style="color:#fff">${Currency.formatCurrency(
                    item.average_ticket.value
                  )}</span>
                </div>`
                  : ""
              }

                            ${
                              selectedOption.id !== "TICKET_MEDIO_LIQUIDO"
                                ? `                <div style="line-height:20px">
                  <span style="color:#fff;opacity:50%">Ticket médio líquido:</span>
                  <span style="color:#fff">${Currency.formatCurrency(
                    item.average_ticket_with_discounts?.value
                  )}</span>
                </div>`
                                : ""
                            }

                                          ${
                                            selectedOption.id !==
                                            "TEMPO_MEDIO_USO"
                                              ? `                <div style="line-height:20px">
                  <span style="color:#fff;opacity:50%">Tempo médio para uso:</span>
                  <span style="color:#fff">${Numbers.formatInt(
                    item.average_time_to_use.value
                  )} dias</span>
                </div>`
                                              : ""
                                          }

                                          ${
                                            selectedOption.id !== "ROI_CUPOM"
                                              ? `                <div style="line-height:20px">
                  <span style="color:#fff;opacity:50%">ROI do cupom:</span>
                  <span style="color:#fff">${
                    isBeforeSeptember ? "---" : item.roi?.value || 0
                  }</span>
                </div>`
                                              : ""
                                          }
              </div>
            `;
          },
        },
        grid: {
          left: 0,
          right: 10,
          top: 30,
          bottom: 0,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data.map((d) => d.date),
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "rgba(217, 217, 217, 0.5)",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "rgba(217, 217, 217, 0.5)",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(51, 51, 51, 0.55)",
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {
              formatter: (value) =>
                [
                  "FATURAMENTO",
                  "FATURAMENTO_LIQUIDO",
                  "TICKET_MEDIO",
                  "TICKET_MEDIO_LIQUIDO",
                  "DESCONTOS_TOTAIS",
                ].includes(selectedOption.id)
                  ? Currency.formatCurrency(value)
                  : Numbers.formatFloat(value),
              color: "rgba(217, 217, 217, 0.5)",
            },
          },
        ],
        series: _data[selectedOptionId].series.map((name, sid, series) => {
          return {
            name,
            type: "bar",
            stack: "total",
            barWidth: "80%",
            data: _data[selectedOptionId].data[sid].map((d, did) =>
              totalData[did] <= 0 ? 0 : d
            ),
            label: {
              show: sid == series.length - 1,
              position: "top",
              lineHeight: 20,
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: 10,
              fontWeight: "semibold",
              formatter: (params) => {
                const index = params.dataIndex;
                const total = _data[selectedOptionId].data.reduce(
                  (acc, curr) => acc + curr[index],
                  0
                );

                if (total <= 0) return "";
                return formatByType(total, _data[selectedOptionId].value_type);
              },
            },
            itemStyle: {
              color: _data[selectedOptionId].colors[sid],
            },
          };
        }),
      };

      options && chart.setOption(options);

      const ro = new ResizeObserver(() => {
        chart.resize();
      });
      ro.observe(chartDOM);

      return () => {
        ro.unobserve(chartDOM);
        ro.disconnect();
        chart.dispose();
      };
    }
  }, [memoData, selectedOption]);

  return (
    <div className={styles.box}>
      <div className="d-flex align-center justify-between mb-20">
        <div className="d-flex align-center gap-5">
          <p className={styles.label}>Cupons no período</p>
          {/* <span className={styles.info}>
            <i className="fal fa-info-circle" />
          </span> */}
        </div>
        <ComboFilters
          options={[
            { name: "Faturamento bruto", id: "FATURAMENTO" },
            { name: "Descontos totais", id: "DESCONTOS_TOTAIS" },
            { name: "Faturamento líquido", id: "FATURAMENTO_LIQUIDO" },
            { name: "Qtd. de usos", id: "QTD_USOS" },
            { name: "Ticket médio bruto", id: "TICKET_MEDIO" },
            { name: "Ticket médio líquido", id: "TICKET_MEDIO_LIQUIDO" },
            { name: "Tempo médio para uso", id: "TEMPO_MEDIO_USO" },
            { name: "ROI do cupom", id: "ROI_CUPOM" },
          ].filter((f) =>
            isBeforeSeptember
              ? f.id !== "ROI_CUPOM" && f.id !== "DESCONTOS_TOTAIS"
              : f
          )}
          onSelect={(option) => setSelectedOption(option)}
          selectedOption={
            selectedOption || { name: "Qtd. de usos", id: "qtd_usos" }
          }
        />
      </div>

      <div className={styles.chart}>
        {_data[selectedOption.id].data[0].every(
          (s) => s === 0 || s === null
        ) ? (
          <div className={styles.emptyChart} style={{ height: 350 }}>
            <span className="text-grey">Não há dados neste período</span>
          </div>
        ) : null}

        <div
          id="coupons-in-period-chart"
          style={{ width: "100%", height: 350 }}
        />
      </div>
    </div>
  );
}
